module.exports = __webpack_public_path__ + "static/media/icon_more_media.b5debda5.svg";